import React from 'react';


function Home({ setCurrentPage }) {
  return (
    <div className="home-container d-flex justify-content-center align-items-center min-vh-100">
      <div className="row justify-content-center w-100">
          <div className="home-card">
          <h1 className='home-heading'>Login With Your Assign Credentials</h1>
            <div className="card-body d-flex justify-content-around">
                            <div className="card shadow-sm w-48 p-3 hover-card">
                <div className="card-body text-center">
                  <i className="bi bi-building-check home-icons display-4 mb-3"></i>
                  <button 
                    className="btn btn-outline-primary w-100"
                    onClick={() => setCurrentPage('OrganizationForm')}
                  >
                    Organization Login
                  </button>
                </div>
              </div>
              <div className="card shadow-sm w-48 p-3 hover-card">
                <div className="card-body text-center">
                  <i className="bi bi-person-workspace home-icons display-4 mb-3"></i>
                  <button 
                    className="btn btn-outline-primary w-100"
                    onClick={() => setCurrentPage('UserLoginForm')}
                  >
                    User Login
                  </button>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  );
}

export default Home;
